export default {
    data () {
        return {
            originalData: null,
            dataPropertyName: 'data' // Override this in components
        }
    },
    methods: {
        initializeTracking (data) {
            this.originalData = JSON.parse(JSON.stringify(data))
        },
        hasChanges () {
            return JSON.stringify(this[this.dataPropertyName]) !== JSON.stringify(this.originalData)
        },
        resetChanges () {
            this.originalData = JSON.parse(JSON.stringify(this[this.dataPropertyName]))
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/shared/change-tracking.js